export default "__VITE_ASSET__D9NVj$$G__"